import { useEffect, useRef, useState } from "react";
import { CreateBase, Form, useDataProvider, useGetIdentity } from "ra-core";
import { Card, CardContent } from "@/components/ui/card";
import { CancelButton } from "@/components/admin/cancel-button";
import { SaveButton } from "@/components/admin/form";
import { Navigate } from "react-router";

import type { CampaignTargetDraft } from "../types";
import { useIsCampaignAdmin } from "./useIsCampaignAdmin";
import { CampaignInputs } from "./CampaignInputs";
import { replaceCampaignTargets } from "./campaignTargets";

export const CampaignCreate = () => {
  const { identity } = useGetIdentity();
  const isAdmin = useIsCampaignAdmin();
  const dataProvider = useDataProvider();
  const targetsRef = useRef<CampaignTargetDraft[]>([]);
  const [targets, setTargets] = useState<CampaignTargetDraft[]>([]);

  useEffect(() => {
    targetsRef.current = targets;
  }, [targets]);

  if (!isAdmin) {
    return <Navigate to="/campaigns" replace />;
  }

  return (
    <CreateBase
      redirect="show"
      mutationOptions={{
        onSuccess: async (record) => {
          if (targetsRef.current.length > 0) {
            await replaceCampaignTargets(
              dataProvider,
              record.id,
              targetsRef.current,
            );
          }
        },
      }}
    >
      <div className="mt-2 flex lg:mr-72">
        <div className="flex-1">
          <Form
            defaultValues={{
              status: "draft",
              created_by: identity?.id,
            }}
          >
            <Card>
              <CardContent>
                <CampaignInputs
                  targets={targets}
                  onTargetsChange={setTargets}
                />
                <div className="sticky flex pt-4 pb-4 md:pb-0 bottom-0 flex-row justify-end gap-2">
                  <CancelButton />
                  <SaveButton />
                </div>
              </CardContent>
            </Card>
          </Form>
        </div>
      </div>
    </CreateBase>
  );
};
